import React from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import LowStockBell from "./LowStockBell";
import { useAuth } from "../lib/auth";
import { Storefront } from "@phosphor-icons/react";

export default function Shell({ children }) {
  return (
    <div className="flex min-h-screen bg-slate-50" data-testid="app-shell">
      <Sidebar />
      <main className="flex-1 min-w-0">
        {children}
      </main>
    </div>
  );
}

/** Shows which store the current page belongs to. Store-scoped routes
 *  (/store/<id>/…) use the store from the URL (authoritative); other pages
 *  show the sidebar's active store in a muted style. */
export function StoreBadge({ className = "" }) {
  const { stores, currentStoreId } = useAuth();
  const { pathname } = useLocation();
  const m = pathname.match(/^\/store\/([^/]+)/);
  const scoped = !!m;
  const store = stores.find((s) => s.id === (m ? m[1] : currentStoreId));
  if (!store) return null;
  return (
    <span
      data-testid="active-store-badge"
      title={scoped ? "This page shows data for this store" : "Active store (selected in the sidebar)"}
      className={`inline-flex items-center gap-1.5 px-2.5 h-7 rounded-full text-[11px] font-semibold border ${scoped ? "bg-emerald-50 text-emerald-800 border-emerald-200" : "bg-slate-100 text-slate-600 border-slate-200"} ${className}`}
    >
      <Storefront size={13} weight="duotone" />
      <span className="truncate max-w-[260px]">{store.name}</span>
      <span className="font-mono-num text-[10px] opacity-70">· {store.code}</span>
    </span>
  );
}

export function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="flex items-start justify-between px-8 pt-7 pb-5 border-b border-slate-200 bg-white" data-testid={testId}>
      <div className="min-w-0">
        <div className="flex items-center gap-3 flex-wrap">
          <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">{title}</h1>
          <StoreBadge />
        </div>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {actions}
        <LowStockBell />
      </div>
    </div>
  );
}
